import RegionCard from './RegionCard';
export default RegionCard;



// WEBPACK FOOTER //
// ./src/scenes/Regions/components/RegionCard/index.js